export default function IconMenuBudgeting({ className }) {
  return (
    <svg
      width="48"
      height="49"
      viewBox="0 0 48 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24.5" r="24" fill="#F5F7F7" />
      <mask
        id="mask0_3517_33957"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="49"
      >
        <circle cx="24" cy="24.5" r="24" fill="#FFF19A" />
      </mask>
      <g mask="url(#mask0_3517_33957)">
        <path
          d="M23.6999 15.5L26.5941 37.4918L23.6999 54.0202H11.6283C10.179 54.0202 9 52.839 9 51.3869V18.1332C9 16.6812 10.179 15.5 11.6283 15.5H23.6999Z"
          fill="#7BCC29"
        />
        <path
          d="M38.4 18.1332V51.3869C38.4 52.839 37.221 54.0202 35.7717 54.0202H23.7001V15.5H35.7717C37.221 15.5 38.4 16.6812 38.4 18.1332Z"
          fill="#6BB91C"
        />
        <mask
          id="mask1_3517_33957"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="23"
          y="15"
          width="16"
          height="40"
        >
          <path
            d="M38.4 18.1332V51.3869C38.4 52.839 37.221 54.0202 35.7717 54.0202H23.7001V15.5H35.7717C37.221 15.5 38.4 16.6812 38.4 18.1332Z"
            fill="#63AC18"
          />
        </mask>
        <g mask="url(#mask1_3517_33957)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M48.6459 14.544V4.70001L53.645 9.63244L53.6451 9.63247L58.6442 14.5441L53.6452 19.4765L58.6442 24.4088L53.645 29.3309V19.4766L48.6459 24.4091V14.5441V14.544ZM53.645 29.3309L58.6442 34.253L53.645 39.175V29.3313L48.6459 34.2534V24.4092L53.645 29.3312V29.3309ZM53.645 9.63251V19.4763V19.4766L48.6459 14.5441L53.645 9.63251ZM43.6467 19.4766V9.63244L48.6458 14.5441L43.6467 19.4766ZM48.5715 44.1936V34.3494L53.5706 39.2714L48.5768 44.1988L53.5706 49.126L48.5715 54.0376V44.204V44.1936ZM48.5715 54.0376L53.5706 58.9701L48.5715 63.9027V54.0376ZM43.5723 49.1261V39.2715L48.5715 44.204L43.5723 49.1261ZM43.5723 49.1261L48.5715 54.0378L43.5724 58.9702L48.5715 63.9027L43.5723 68.8246V58.9703V58.9702V49.1261ZM28.5481 54.1096V44.2973L28.5322 44.3129V34.4688L33.5314 39.3908L28.5642 44.2815L33.5314 49.1721V39.3909L38.5305 44.313L33.5633 49.2037L38.5456 54.1197V54.1096V44.2981L38.5306 44.3129V34.4688L43.5297 39.3908L38.5621 44.2819L43.5447 49.1876L38.551 54.1149L43.5447 59.0421L38.5458 63.9535L38.5463 63.954L38.5459 63.9544L43.5447 68.8866L38.5459 73.8188L38.5463 73.8192L33.5473 78.7411V68.8867L38.5456 73.8185V63.9547L33.5473 68.8865V59.0425V59.0424V49.2195L33.5314 49.2351V49.2033L28.5535 54.1149L33.5472 59.0421L28.5481 63.9537V54.1202V54.1096ZM28.5322 44.313L23.5649 49.2037L28.548 54.1204L23.549 59.0425L28.548 63.954L23.5489 68.8865V59.0425V59.0424V49.2195L23.5331 49.2351V39.3909L28.5322 44.313ZM23.5489 78.7411V68.8867L28.548 73.8192L23.5489 78.7411ZM28.5481 63.9539V73.819L33.5472 68.8865L28.5481 63.9539ZM33.5474 59.0425L38.5456 54.1211V63.9532L33.5474 59.0425ZM43.5723 78.669V68.8247L48.5715 73.7468L43.5723 78.669ZM48.5715 73.7469V63.9027L53.5706 68.8248L48.5715 73.7469ZM53.5707 68.8247L58.5697 73.7468L53.5707 78.669V68.8247ZM53.5707 49.1261V58.9702V58.9703V68.8247L58.5697 63.9027L53.5707 58.9702L58.5697 54.0378L53.5707 49.1261ZM53.5707 49.1261V39.2715L58.5697 44.204L53.5707 49.1261ZM58.5698 63.9026V54.0376L63.5689 58.9701L58.5698 63.9026ZM58.5698 54.0376L63.5689 49.126L58.5751 44.1988L63.5689 39.2714L58.5698 34.3494V44.1936V44.204V54.0376ZM58.5698 63.9027V73.7469L63.5689 68.8248L58.5698 63.9027ZM43.6467 29.3312V39.175L48.6458 34.253L43.6469 29.331L48.6458 24.4091L43.6467 19.4766V29.3309V29.3312ZM58.6442 14.5441V24.409L63.6434 19.4765L58.6442 14.5441ZM58.6442 14.5441V4.70001L63.6434 9.63247L58.6442 14.5441ZM58.6442 24.4092V34.2534L63.6434 29.3313L58.6442 24.4092ZM23.5331 19.692V9.83774L28.5322 14.7702L23.5332 19.6922L28.5322 24.6037L23.5331 29.5363L28.5322 34.4687L23.5331 39.3908V29.5363V29.5362V19.6923V19.692ZM28.5322 14.7702V24.6036V24.6037V34.4687L33.5314 29.5362L28.5323 24.6037L33.5314 19.6919L28.5376 14.7649L33.5314 9.83775L28.5322 4.91573V14.7596V14.7702ZM33.5314 19.6923V29.5362V29.5363V39.3908L38.5305 34.4687L33.5314 29.5363L38.5305 24.6037L33.5315 19.6922L38.5305 14.7702L33.5314 9.83774V19.692V19.6923ZM38.5306 34.4687V24.6038L43.5297 29.5362L38.5306 34.4687ZM38.5306 14.7702V24.6037L43.5297 19.6919L38.5359 14.7649L43.5297 9.83775L38.5306 4.91573V14.7596V14.7702Z"
            fill="#5D9F19"
          />
        </g>
        <path
          d="M23.6999 20.2398L25.1084 24.152L23.6999 29.1175H16.5426C15.5078 29.1175 14.6652 28.2741 14.6652 27.2366V22.1207C14.6652 21.0832 15.5078 20.2398 16.5426 20.2398H23.6999Z"
          fill="#A2F053"
        />
        <path
          d="M32.7347 22.1207V27.2366C32.7347 28.2741 31.8921 29.1175 30.8573 29.1175H23.7V20.2398H30.8573C31.8921 20.2398 32.7347 21.0832 32.7347 22.1207Z"
          fill="#99E34D"
        />
        <path
          d="M17.7436 33.5061H16.4424C15.8203 33.5061 15.316 34.0114 15.316 34.6346C15.316 35.2579 15.8203 35.7631 16.4424 35.7631H17.7436C18.3657 35.7631 18.87 35.2579 18.87 34.6346C18.87 34.0114 18.3657 33.5061 17.7436 33.5061Z"
          fill="#A2F053"
        />
        <path
          d="M23.6999 33.5059L24.0566 34.6344L23.6999 35.7629H23.0496C22.427 35.7629 21.9231 35.2581 21.9231 34.6344C21.9231 34.0114 22.427 33.5059 23.0496 33.5059H23.6999Z"
          fill="#A2F053"
        />
        <path
          d="M25.4767 34.6344C25.4767 35.2581 24.9728 35.7629 24.3503 35.7629H23.7V33.5059H24.3503C24.9728 33.5059 25.4767 34.0114 25.4767 34.6344Z"
          fill="#A2F053"
        />
        <path
          d="M30.9575 33.5061H29.6564C29.0343 33.5061 28.5299 34.0114 28.5299 34.6346C28.5299 35.2579 29.0343 35.7631 29.6564 35.7631H30.9575C31.5796 35.7631 32.084 35.2579 32.084 34.6346C32.084 34.0114 31.5797 33.5061 30.9575 33.5061Z"
          fill="#A2F053"
        />
        <path
          d="M30.9575 39.7969H29.6564C29.0343 39.7969 28.5299 40.3022 28.5299 40.9255C28.5299 41.5487 29.0343 42.054 29.6564 42.054H30.9575C31.5796 42.054 32.084 41.5487 32.084 40.9255C32.084 40.3022 31.5797 39.7969 30.9575 39.7969Z"
          fill="#A2F053"
        />
        <path
          d="M17.7436 39.8008H16.4424C15.8203 39.8008 15.316 40.3061 15.316 40.9293C15.316 41.5525 15.8203 42.0578 16.4424 42.0578H17.7436C18.3657 42.0578 18.87 41.5525 18.87 40.9293C18.87 40.3061 18.3657 39.8008 17.7436 39.8008Z"
          fill="#A2F053"
        />
        <path
          d="M23.6999 39.8008L24.2068 40.9293L23.6999 42.0578H23.0496C22.427 42.0578 21.9231 41.5522 21.9231 40.9293C21.9231 40.3064 22.427 39.8008 23.0496 39.8008H23.6999Z"
          fill="#A2F053"
        />
        <path
          d="M25.4767 40.9293C25.4767 41.5522 24.9728 42.0578 24.3503 42.0578H23.7V39.8008H24.3503C24.9728 39.8008 25.4767 40.3064 25.4767 40.9293Z"
          fill="#A2F053"
        />
        <g clipPath="url(#clip0_3517_33957)">
          <path
            d="M24 24.5001C29.2467 24.5001 33.5 20.2468 33.5 15.0001C33.5 9.75336 29.2467 5.50006 24 5.50006C18.7533 5.50006 14.5 9.75336 14.5 15.0001C14.5 20.2468 18.7533 24.5001 24 24.5001Z"
            fill="#FFE14D"
          />
          <path
            d="M33.5 15.0001C33.5 9.76174 29.2383 5.50006 24 5.50006L24 24.5001C29.2383 24.5001 33.5 20.2384 33.5 15.0001Z"
            fill="#FFBB33"
          />
          <path
            d="M24 22.2364C20.01 22.2364 16.7637 18.9901 16.7637 15.0001C16.7637 11.0101 20.01 7.76373 24 7.76373C27.99 7.76373 31.2363 11.0101 31.2363 15.0001C31.2363 18.9901 27.99 22.2364 24 22.2364Z"
            fill="#FFBB33"
          />
          <path
            d="M31.2363 15.0001C31.2363 11.0101 27.99 7.76373 24 7.76373L24 22.2364C27.99 22.2364 31.2363 18.9901 31.2363 15.0001Z"
            fill="#EC8824"
          />
          <path
            d="M20.1066 16.1985C20.1066 16.4614 20.3234 16.6693 20.5977 16.6693C20.872 16.6693 21.0888 16.4614 21.0888 16.1985L21.0888 15.263H21.8734L22.8301 16.4247C22.9449 16.5654 23.0916 16.6693 23.3149 16.6693C23.5509 16.6693 23.7805 16.4981 23.7805 16.2352C23.7805 16.0884 23.7167 15.9906 23.621 15.8744L22.9386 15.0796C23.4807 14.8656 23.8315 14.4498 23.8315 13.7772L23.8315 13.765C23.8315 13.3614 23.6976 13.0251 23.4488 12.7867C23.1554 12.5054 22.7153 12.3525 22.1476 12.3525H20.5977C20.3234 12.3525 20.1066 12.5604 20.1066 12.8233L20.1066 16.1985ZM21.0888 14.4314L21.0888 13.2024H22.0647C22.5431 13.2024 22.8365 13.4103 22.8365 13.8139L22.8365 13.8261C22.8365 14.1869 22.5622 14.4314 22.0839 14.4314H21.0888Z"
            fill="#FFEE99"
          />
          <path
            d="M24.6139 17.1829C24.6139 17.4397 24.8307 17.6476 25.0986 17.6476C25.3665 17.6476 25.5834 17.4397 25.5834 17.1829L25.5834 16.2046C25.813 16.4675 26.1319 16.6938 26.6486 16.6938C27.4586 16.6938 28.2049 16.0946 28.2049 15.0001L28.2049 14.9879C28.2049 13.8934 27.4459 13.2942 26.6486 13.2942C26.1447 13.2942 25.8194 13.5204 25.5834 13.8261L25.5834 13.7833C25.5834 13.5265 25.3665 13.3186 25.0986 13.3186C24.8307 13.3186 24.6139 13.5265 24.6139 13.7833L24.6139 17.1829ZM26.3998 15.905C25.947 15.905 25.5706 15.5443 25.5706 15.0001L25.5706 14.9879C25.5706 14.4437 25.947 14.0829 26.3998 14.0829C26.8527 14.0829 27.2354 14.4437 27.2354 14.9879L27.2354 15.0001C27.2354 15.5504 26.8527 15.905 26.3998 15.905Z"
            fill="#FFEE99"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3517_33957">
          <rect
            width="19"
            height="19"
            fill="white"
            transform="translate(14.5 5.50006)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
